module.exports = __webpack_public_path__ + "img/fan04.192a4c05.png";